import { useEffect, useMemo, useState } from "react";
import { loadRemote } from "./loadRemote";
import { replaceBracedComponentsInBaseUrl } from "./replaceBracedComponentsInBaseUrl";
import { localiseForLocale, configMerge } from "./utils";
const DEFAULT_CONFIG = {
    config_status: "published",
    locale: "en_GB",
    completions: {
        limit: 5,
        minQueryLength: 3,
    },
    intlData: {
        messages: {},
        formats: {
            number: {
                distance: {
                    unit: "km",
                    style: "decimal",
                    maximumFractionDigits: 2,
                },
            },
        },
    },
};
export const AUTH_ERROR_MESSAGE = "config auth error";
export const useInitalisedConfig = ({ localConfig, location, transformQueryParams, }) => {
    const [finalConfig, setFinalConfig] = useState(null);
    const queryConfig = useMemo(() => {
        const queryParams = Object.fromEntries(new URL(location.href).searchParams.entries());
        if (!transformQueryParams)
            return queryParams;
        return transformQueryParams(queryParams);
    }, []);
    const temporaryConfig = useMemo(() => {
        const tempSettings = configMerge(DEFAULT_CONFIG, localConfig, queryConfig);
        return localiseForLocale(tempSettings, tempSettings.locale);
    }, [localConfig, queryConfig]);
    useEffect(() => {
        loadRemote(temporaryConfig)
            .then((remoteConfig) => {
            const mergedConfig = configMerge(DEFAULT_CONFIG, remoteConfig, localiseForLocale(localConfig, temporaryConfig.locale), queryConfig);
            const transformedConfig = replaceBracedComponentsInBaseUrl(mergedConfig);
            setFinalConfig(transformedConfig);
        })
            .catch((err) => {
            if (err.message === AUTH_ERROR_MESSAGE && temporaryConfig.authFailureRedirect)
                location.href = temporaryConfig.authFailureRedirect;
        });
    }, [temporaryConfig]);
    return finalConfig;
};
